import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Scroll from 'react-scroll';
// import Isvg from 'react-inlinesvg';

import { Link } from 'react-router-dom';
import { getFAQs } from '../../actions/applicationData';
import { updateAppState } from '../../actions/applicationState';
import { logout } from '../../actions/user';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import Body from '../../components/Body';
import DashboardHeader from '../../components/DashboardHeader';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';

import ContentContainer from '../../components/ContentContainer';
import FAQ from '../../components/FAQ';

const ScrollLink = Scroll.Link;
const ScrollElement = Scroll.Element;
// const ICON1_ASSET = require('./assets/icon_1.svg');

class FAQs extends Component {
  constructor(props) {
    super(props);
    this.setQuestion = this.setQuestion.bind(this);
    this.renderFAQs = this.renderFAQs.bind(this);
    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);

    this.state = {
      posts: [],
      loaded: false,
      question: null,
    };
  }

  componentWillMount() {
    // Skip API calls during react-snap pre-rendering
    if (navigator.userAgent === 'ReactSnap') {
      this.setState({
        loaded: true,
        posts: {
          borrower: [{ id: 1, question: 'Loading...', answer: 'Loading...' }],
          owner: [{ id: 2, question: 'Loading...', answer: 'Loading...' }],
        },
        question: 1,
      });
      return;
    }

    this.fetchFAQs();
  }

  componentDidUpdate(prevProps) {
    if (this.state.loaded && prevProps.type !== this.props.type) {
      setTimeout(() => {
        this.setState({
          question: this.state.posts[this.props.type][0].id,
        });
      }, 50);
    }
  }

  setQuestion(faqID) {
    this.setState({ question: faqID });
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  loginModalOpenHandler() {
    this.props.dispatch(
      updateAppState({
        login_modal_open: true,
      }),
    );
  }

  fetchFAQs() {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props.dispatch(getFAQs()).then(
          response => {
            this.setState({
              posts: response,
              loaded: true,
              question: response[this.props.type][0].id,
            });

            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
          err => {
            console.log(err); // eslint-disable-line no-console
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
            this.props.history.push('/404');
          },
        );
      });
  }

  renderFAQs(data) {
    return (
      <div className={css(styles.faqs_container)}>
        <div className={css(styles.menu)}>
          {data.map(faq => (
            <ScrollLink
              to="faq-container"
              smooth
              duration={800}
              offset={Theme.isMobile ? -80 : -180}
              className={css(
                styles.menu_trigger,
                this.state.question === faq.id ? styles.menu_trigger_active : null,
              )}
              onClick={() => this.setQuestion(faq.id)}
              key={`faq-question-${faq.id}`}
            >
              {faq.question}
            </ScrollLink>
          ))}
        </div>

        <ScrollElement name="faq-container" className={css(styles.main)}>
          {data.map(faq => (
            <FAQ
              id={faq.id}
              question={faq.question}
              visible={this.state.question === faq.id}
              key={`faq-answer-${faq.id}`}
            >
              {faq.answer}
            </FAQ>
          ))}
        </ScrollElement>
      </div>
    );
  }

  render() {
    const pageTitle =
      this.props.type === 'borrower' ? 'FAQs for Dog Borrowers' : 'FAQs for Dog Owners';
    const pageDescription =
      this.props.type === 'borrower'
        ? 'Common questions about borrowing dogs through The Dog Share Collective. Learn about safety, matching, and getting started.'
        : 'Common questions for dog owners about sharing your dog. Learn about safety, vetting borrowers, and the sharing process.';

    return (
      <Body hasFooter>
        <SEO
          title={pageTitle}
          description={pageDescription}
          keywords="dog sharing faq, frequently asked questions, dog borrowing, dog owner questions"
          url={`https://www.thedogsharecollective.com/faqs-dog-${this.props.type}`}
        />
        {this.props.user.isAuthenticated ? (
          <DashboardHeader
            logoutHandler={this.logoutHandler}
            redirectHandler={this.redirectHandler}
            {...this.props}
          />
        ) : (
          <UnauthenticatedHeader openLoginHandler={this.openLoginHandler} />
        )}
        <div className={css(styles.heading_section)}>
          <ContentContainer styles={styles.body_container}>
            <h1 className={css(styles.heading)}>How can we help?</h1>
            <div className={css(styles.tabs)}>
              <Link to="/faqs-dog-borrower">
                <div
                  className={css(
                    styles.tab,
                    this.props.type === 'borrower' ? styles.tab_active : null,
                  )}
                >
                  {"I'm a borrower"}
                </div>
              </Link>
              <Link to="/faqs-dog-owner">
                <div
                  className={css(
                    styles.tab,
                    this.props.type === 'owner' ? styles.tab_active : null,
                  )}
                >
                  {"I'm an owner"}
                </div>
              </Link>
            </div>
          </ContentContainer>
        </div>
        <ContentContainer styles={styles.container}>
          {this.state.loaded ? this.renderFAQs(this.state.posts[this.props.type]) : false}
        </ContentContainer>
        <Footer user={this.props.user} />
      </Body>
    );
  }
}

FAQs.defaultProps = {
  type: 'borrower',
};

FAQs.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string,
};

const styles = StyleSheet.create({
  faqs_container: {
    display: 'flex',
    padding: '60px 0 105px',
    lineHeight: '24px',
    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  body_container: {
    paddingTop: 50,
  },
  menu: {
    flexShrink: 0,
    width: 348,
    backgroundColor: Theme.white,
  },
  menu_trigger: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 60,
    width: '100%',
    padding: '0 27px',
    textAlign: 'left',
    fontSize: 16,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    color: '#000e1f',
    lineHeight: '1.1',
    backgroundColor: Theme.white,
    border: 0,
    borderLeft: '8px solid #000e1f',
    outline: 'none',
    cursor: 'pointer',
    transition: 'all 300ms',
  },
  menu_trigger_active: {
    color: Theme.white,
    borderColor: '#f0f0f0',
    backgroundColor: '#000e1f',
  },
  main: {
    paddingLeft: 43,
    [Theme.mobile_query]: {
      padding: '40px 15px',
    },
  },
  container: {
    display: 'flex',
    padding: '60px 0 105px',
    lineHeight: '24px',
  },
  heading_section: {
    paddingTop: 74,
    backgroundColor: '#f9f9f9',
  },
  heading: {
    marginBottom: 42,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  tabs: {
    display: 'flex',
    justifyContent: 'center',
  },
  tab: {
    padding: '0 25px 17px',
    fontSize: 14,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    letterSpacing: 1.9,
    lineHeight: 1.86,
    textTransform: 'uppercase',
    color: '#4a4a4a',
    backgroundColor: 'transparent',
    border: 0,
    borderBottom: '4px solid transparent',
    outline: 'none',
    cursor: 'pointer',
    transition: 'all 300ms',

    ':hover': {
      color: '#39b4d6',
      borderColor: '#39b4d6',
    },
  },
  tab_active: {
    color: '#39b4d6',
    borderColor: '#39b4d6',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FAQs);



// WEBPACK FOOTER //
// ./src/views/FAQs/index.js